import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthUserToken } from "../hooks/useAuthUserToken";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ element: Component, allowedRoles, requiredPermission }) => {
  const { completeAuthData: authData, rbac } = useAuthUserToken();
  const { isLoggedIn } = useSelector((state) => state.clientData);
  const { role } = authData;
  const hasPermission = rbac?.[requiredPermission];

  return (
    <>
      {isLoggedIn ?
        (authData && hasPermission && allowedRoles.includes(role) ? (
          <Component />
        ) : (
          <Navigate to="/403" />)
        ) : (
          <Navigate to="/login" />
        )}
    </>
  )

};

export default ProtectedRoute;